import { useRef, useState } from "react";
import { ControlOptions } from "leaflet";
import { Paper, Popper, styled, Tooltip } from "@mui/material";
import { Search } from "@mui/icons-material";

import { useTranslation } from "react-i18next";

import { MapControlBase } from "./MapControlBase";
import { ActiveFab } from "../button/ActiveFab";
import { LocationSearch } from "../location/LocationSearch";

interface Props extends ControlOptions {
  type: string;
}

export function MapSearchControl(props: Props) {
  const { type, ...controlProps } = props;
  const anchorEl = useRef<HTMLButtonElement | null>(null);
  const [active, setActive] = useState(false);
  const { t } = useTranslation();

  return (
    <MapControlBase {...controlProps}>
      <Tooltip
        title={!active ? t("label.searchALocation").toString() : ""}
        placement="left"
      >
        <ActiveFab
          ref={anchorEl}
          className={active ? "active" : "inactive"}
          size="small"
          variant="circular"
          onClick={() => setActive(!active)}
        >
          <Search />
        </ActiveFab>
      </Tooltip>
      <Popper open={active} anchorEl={anchorEl.current} placement="left-start">
        <Styles>
          <LocationSearch type={type} onClose={() => setActive(false)} />
        </Styles>
      </Popper>
    </MapControlBase>
  );
}

const Styles = styled(Paper)`
  margin-right: ${({ theme }) => theme.spacing(2)};
`;
